import type { FaireProductEntity } from "../../entity_types/product";

export const p_4mh6p4c8fs: FaireProductEntity = {
  token: "p_4mh6p4c8fs",
  type: "product",
  name: "Very Happy Tissue Paper",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/39f4cd150ad6b0ea6e02212bc54a57e89a36dee624778051539711a752927d82.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f2cb04c4d65773b8cc1ce2d84abea9dd36b73e5caab31d90e276a5348172bf8a.png",
    "https://cdn.faire.com/fastly/9a6448e03aea37fcbe46e8428fdc66c8e7596f4201eea2e46a0b78c9632f5ed5.png",
  ],
  priceDollars: 4,
  description:
    "Each package contains 10 generously sized sheets of tissue paper to mix and match with our coordinating gift bags (sold separately). The weirdly best part—unused tissue easily slides back into the envelope for organized storage, no more loose, crinkled foldy piles!",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:03.119Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
